<template>
  <!-- ประเภท: การประชุม / ลงทะเบียน (กำหนดข้อความที่ผู้สแกนเห็นเมื่อลงทะเบียนสำเร็จ) -->
  <div class="type-picker">
    <div class="type-label">ประเภท</div>
    <v-btn-toggle :value="value" mandatory color="primary" class="type-toggle" @change="$emit('input', $event)">
      <v-btn v-for="t in types" :key="t.value" :value="t.value" class="type-btn">{{ t.label }}</v-btn>
    </v-btn-toggle>
  </div>
</template>

<script>
import { MEETING_TYPES, DEFAULT_TYPE } from '@/meetingType';

export default {
  name: 'MeetingTypePicker',
  props: {
    value: { type: String, default: DEFAULT_TYPE },
  },
  data() {
    return { types: MEETING_TYPES };
  },
};
</script>

<style scoped>
.type-picker {
  margin-bottom: 16px;
}

.type-label {
  margin-bottom: 8px;
  color: #0C2F53;
  font-size: 15px;
  font-weight: 600;
}

.type-btn {
  min-width: 120px !important;
  font-size: 15px;
  letter-spacing: 0;
}
</style>
